import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-derechos-paso',
    templateUrl: './derechos-paso.component.html',
    styleUrls: ['./derechos-paso.component.scss']
})
export class DerechosPasoComponent implements OnInit {
    @Input() id: any;
    @Input() dataDerechoPaso: any;

    FormTransporte = new FormGroup({
        id: new FormControl('', [Validators.required]),
        TipoDerechoDePaso: new FormControl('', [Validators.required]),
        KilometrajePagado: new FormControl('', [Validators.required]),
    });

    opcionesTipoDerechoPaso: Observable<any[]>;
    lstTipoDerechoPaso: any;

    constructor(private sharedService: SharedService, private srvcoal: CoalService,) { }

    ngOnInit(): void {
        this.GetDerechosPasos();
        this.FormTransporte.controls.id.setValue(this.id.id)
        this.FormTransporte.valueChanges.subscribe(changes => {
            if (this.FormTransporte.valid) {
                console.log("Validacion setFormFerroviariosPaso : ", this.FormTransporte.value);
                this.sharedService.setFormFerroviariosPaso(changes);
            }
        });

      
    }

    GetDerechosPasos() {
        this.srvcoal.getService(`cat-tipo-derecho-pasos`,).subscribe((res: any) => {
            if (res.err) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.lstTipoDerechoPaso = res.data;
                if (this.dataDerechoPaso) {
                    console.log('Es actualizacion dataDerechoPaso', this.dataDerechoPaso)
                    // datoPaso
                    this.FormTransporte.patchValue({
                        TipoDerechoDePaso: this.dataDerechoPaso.TipoDerechoDePaso,
                        KilometrajePagado: this.dataDerechoPaso.KilometrajePagado
                    });
                }
                this.opcionesTipoDerechoPaso = this.FormTransporte.get('TipoDerechoDePaso').valueChanges.pipe(
                    startWith(''),
                    map(state => (state ? this._filtrarTipoDerechoPaso(state) : this.lstTipoDerechoPaso)),
                );


            }
            // this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            // this.store.dispatch(OcultarSpinner())
        });
    }

    displayTipoDerechoPaso = (bienes: any): string => {
        const servicioEncontrado = this.lstTipoDerechoPaso.find((f: any) => f.id === bienes);
        if (servicioEncontrado) {
            return `${servicioEncontrado.attributes.clave} - ${servicioEncontrado.attributes.derechoPaso}`;
        } else {
            return '';
        }
    }

    private _filtrarTipoDerechoPaso(value: any): any[] {
        const filterValue = value?.toLowerCase();

        return this.lstTipoDerechoPaso.filter(unidad =>
        (unidad.attributes.clave.toLowerCase().includes(filterValue) ||
            unidad.attributes.derechoPaso.toLowerCase().includes(filterValue))
        );
    }

}
